import { createAction } from '@reduxjs/toolkit';
import { type RouteCollapsingLevel } from '../../../_shared/constants/routeCollapsingLevel.enum';
import { type RouteUiData } from '../../frontendState/mapTools/directions/directions.state';
import {
  MAP_SETTINGS_DIRECTIONS_MODIFY_ROUTE,
  MAP_SETTINGS_DIRECTIONS_SET_DIRECTION_SETTINGS,
} from './mapSettingsDirections.actionTypes';
import { type MapSettingsRoute } from './mapSettingsDirections.state';

export const setMapDirectionSettings = (
  selectedCollapsing: RouteCollapsingLevel,
  canDragRoutes: boolean,
  shouldBeginAtUserLocation: boolean,
  areMarkersCollapsed: boolean,
) => ({
  type: MAP_SETTINGS_DIRECTIONS_SET_DIRECTION_SETTINGS,
  payload: {
    selectedCollapsing,
    canDragRoutes,
    shouldBeginAtUserLocation,
    areMarkersCollapsed,
  },
}) as const;

export const addOrUpdateRoute = createAction(
  'MAP_SETTINGS_DIRECTIONS/ADD_OR_UPDATE_ROUTE',
  (params: {
    route: MapSettingsRoute;
    routeUiData?: RouteUiData;
    routeCollapsingLevel?: RouteCollapsingLevel;
  }) => ({
    payload: {
      ...params,
    },
  }),
);

export const removeRouteFromDirections = createAction(
  'MAP_SETTINGS_DIRECTIONS/REMOVE_ROUTE',
  (route: MapSettingsRoute, mapId: number) => ({
    payload: {
      route,
      mapId,
    },
  })
);

export const modifyRouteInDirections = (routeId: string, route: MapSettingsRoute) => ({
  type: MAP_SETTINGS_DIRECTIONS_MODIFY_ROUTE,
  payload: {
    routeId,
    route,
  },
}) as const;

export const clearDirectionsRoutes = createAction(
  'MAP_SETTINGS_DIRECTIONS/CLEAR_ROUTES',
);
